// extracted by mini-css-extract-plugin
export default {"pageWrapper":"pageWrapper-2hahdm","header":"header-1qQw_H","linkText":"linkText-34VwHT"};